import { NavigationHeaderContext } from "./NavigationHeaderContext";
import { IdcardOutlined } from '@ant-design/icons';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
var HeaderAccountBtn = function HeaderAccountBtn() {
  var NavigationHeaderContextProps = useContext(NavigationHeaderContext);
  var testPassportUrl = NavigationHeaderContextProps.testPassportUrl,
    prodPassportUrl = NavigationHeaderContextProps.prodPassportUrl,
    env = NavigationHeaderContextProps.env;
  return /*#__PURE__*/React.createElement("div", {
    className: "dr-nav-icon-item",
    onClick: function onClick() {
      window.open(env === 'test' ? testPassportUrl : prodPassportUrl);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "icon-wrapper"
  }, /*#__PURE__*/React.createElement(IdcardOutlined, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "login.account.title"
  })));
};
export default HeaderAccountBtn;